import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة مساحة خزان - حساب مساحة الخزان بناءً على الأبعاد";
const DESCRIPTION =
  "حاسبة مساحة الخزان الدقيقة: احسب المساحة السطحية الكلية للخزانات المستطيلة أو الأسطوانية أو المركبة! أدخل الأبعاد (الطول، العرض، الارتفاع) للحصول على مساحة الخزان بالأمتار المربعة - مثالية للهندسة المدنية والتصنيع.";
const KEYWORDS = "مساحة الخزان, حساب مساحة الخزان, حاسبة مساحة خزان";
const OG_URL = "https://do-calculate.com/calculator/ar/tank-area/";
function Calculator() {
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [totalArea, setTotalArea] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!length || !width || !height) {
      setError("الرجاء إدخال الأبعاد بشكل صحيح");
      setTotalArea("");
      return;
    }
    const lengthValue = parseFloat(length);
    const widthValue = parseFloat(width);
    const heightValue = parseFloat(height);
    if (
      isNaN(lengthValue) ||
      isNaN(widthValue) ||
      isNaN(heightValue) ||
      lengthValue <= 0 ||
      widthValue <= 0 ||
      heightValue <= 0
    ) {
      setError("الرجاء إدخال قيم صحيحة وإيجابية للأبعاد");
      setTotalArea("");
      return;
    }
    const surfaceArea =
      2 *
      (lengthValue * widthValue +
        lengthValue * heightValue +
        widthValue * heightValue);
    setTotalArea(surfaceArea.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب مساحة خزان </h2>
                <p>
                  الخزان هو عبارة عن مجسم يتكون من 6 مستطيلات أو مربعات، ومساحة
                  الخزان تحسب بناءً على الأبعاد.
                </p>
                <p>
                  مساحة الخزان = 2 * (الطول * العرض + الطول * الارتفاع + العرض *
                  الارتفاع)
                </p>
                <p>
                  يمكن استخدام هذه الحاسبة لحساب مساحة الخزان بناءً على الأبعاد
                  المُدخلة.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الطول (متر)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="الطول"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">العرض (متر)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="العرض"
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          الارتفاع (متر)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="الارتفاع"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب مساحة الخزان
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {totalArea !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              مساحة الخزان (متر مربع): {totalArea}
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحل: <br />- قم بحساب مساحة كل مستطيل من
                              المستطيلات الستة. - ثم اجمع مساحات الستة مستطيلات
                              للحصول على المساحة الكلية للخزان.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
